var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isA)?_c('a',{staticClass:"pz-nav-link",attrs:{"href":_vm.url}},[_vm._t("default")],2):_c('router-link',{staticClass:"pz-nav-link",attrs:{"to":_vm.url}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }